import React, { useEffect, useRef } from "react";

const ApartmentItem = ({
	prices,
	layout,
	properties,
	modifyPrice,
	enums,
	levels,
	id,
}) => {
	const link = `/projects/${levels.complex.properties.alias.value}/apartments/${id}/`;
	const isEnglish = document.body.classList.contains("en");
	const slider = useRef();
	const bullets = useRef();

	useEffect(() => {
		new Swiper(slider.current, {
			slidesPerView: 1,
			spaceBetween: 50,
			loop: true,
			pagination: {
				el: bullets.current,
				renderBullet: function (index, className) {
					return '<li class="' + className + '" + ></li>';
				},
			},
		});
	}, []);

	return (
		<a href={link}>
			<div className="header">
				{levels.complex.id != "43906" ? (
					<h3>
						{enums.type && enums.type.valueTitle}
						{","} {layout.areas.full.value.toLocaleString("ru-RU")}{" "}
						{isEnglish ? "sq. m." : "м²"}
					</h3>
				) : (
					<h3>
						{layout.properties.type_en &&
							(isEnglish
								? layout.properties.type_en.value
								: layout.properties.type.value)}
						{","} {layout.areas.full.value.toLocaleString("ru-RU")}{" "}
						{isEnglish ? "sq. m." : "м²"}
					</h3>
				)}

				<ul>
					<li>
						{isEnglish ? "Building" : "Корпус"} {levels.section.name}
					</li>
					<li>№ {properties.number.value}</li>
					<li>
						{isEnglish ? "Floor" : "Этаж"} {levels.floor.name}
					</li>
				</ul>
			</div>
			<div ref={slider} className="slider chooserSlider">
				<ul className="swiper-wrapper">
					<li className="swiper-slide">
						<picture>
							<img
								src={layout.properties.image.value}
								alt={layout.properties.image.title}
							/>
						</picture>
					</li>
					{layout.properties.image_additional !== undefined ? (
						<li className="swiper-slide">
							<picture>
								<img
									src={layout.properties.image_additional.value}
									alt={layout.properties.image_additional.title}
								/>
							</picture>
						</li>
					) : (
						""
					)}
				</ul>
			</div>
			<ul ref={bullets} className="swiper-pagination"></ul>
			<h3 className="h5">{modifyPrice(prices.total.value)} ฿</h3>
			<div className="info">
				<ul>
					{enums.promo_apart && enums.promo_apart.value === "yes" ? (
						<li className="hot-deal">
							<svg
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M5.0013 7.33332C4.35686 7.33332 3.80686 7.10555 3.3513 6.64999C2.89575 6.19443 2.66797 5.64443 2.66797 4.99999C2.66797 4.35555 2.89575 3.80555 3.3513 3.34999C3.80686 2.89443 4.35686 2.66666 5.0013 2.66666C5.64575 2.66666 6.19575 2.89443 6.6513 3.34999C7.10686 3.80555 7.33464 4.35555 7.33464 4.99999C7.33464 5.64443 7.10686 6.19443 6.6513 6.64999C6.19575 7.10555 5.64575 7.33332 5.0013 7.33332ZM5.0013 5.99999C5.27908 5.99999 5.51519 5.90277 5.70964 5.70832C5.90408 5.51388 6.0013 5.27777 6.0013 4.99999C6.0013 4.72221 5.90408 4.4861 5.70964 4.29166C5.51519 4.09721 5.27908 3.99999 5.0013 3.99999C4.72352 3.99999 4.48741 4.09721 4.29297 4.29166C4.09852 4.4861 4.0013 4.72221 4.0013 4.99999C4.0013 5.27777 4.09852 5.51388 4.29297 5.70832C4.48741 5.90277 4.72352 5.99999 5.0013 5.99999ZM11.0013 13.3333C10.3569 13.3333 9.80686 13.1055 9.3513 12.65C8.89575 12.1944 8.66797 11.6444 8.66797 11C8.66797 10.3555 8.89575 9.80554 9.3513 9.34999C9.80686 8.89443 10.3569 8.66666 11.0013 8.66666C11.6457 8.66666 12.1957 8.89443 12.6513 9.34999C13.1069 9.80554 13.3346 10.3555 13.3346 11C13.3346 11.6444 13.1069 12.1944 12.6513 12.65C12.1957 13.1055 11.6457 13.3333 11.0013 13.3333ZM11.0013 12C11.2791 12 11.5152 11.9028 11.7096 11.7083C11.9041 11.5139 12.0013 11.2778 12.0013 11C12.0013 10.7222 11.9041 10.4861 11.7096 10.2917C11.5152 10.0972 11.2791 9.99999 11.0013 9.99999C10.7235 9.99999 10.4874 10.0972 10.293 10.2917C10.0985 10.4861 10.0013 10.7222 10.0013 11C10.0013 11.2778 10.0985 11.5139 10.293 11.7083C10.4874 11.9028 10.7235 12 11.0013 12ZM3.13464 12.8667C3.01241 12.7444 2.9513 12.5889 2.9513 12.4C2.9513 12.2111 3.01241 12.0555 3.13464 11.9333L11.9346 3.13332C12.0569 3.0111 12.2124 2.94999 12.4013 2.94999C12.5902 2.94999 12.7457 3.0111 12.868 3.13332C12.9902 3.25555 13.0513 3.4111 13.0513 3.59999C13.0513 3.78888 12.9902 3.94443 12.868 4.06666L4.06797 12.8667C3.94575 12.9889 3.79019 13.05 3.6013 13.05C3.41241 13.05 3.25686 12.9889 3.13464 12.8667Z"
									fill="white"
								/>
							</svg>

							<span>{isEnglish ? "Hot Deal" : "Hot Deal"}</span>
						</li>
					) : (
						""
					)}
					{levels.complex.id == "43336" ? (
						<li>
							{(enums.type && enums.type.valueTitle === "Duplex" && (
								<span>{isEnglish ? "Private garden" : "Свой двор"}</span>
							)) || <span>{isEnglish ? "Private pool" : "Свой бассейн"}</span>}
						</li>
					) : (
						""
					)}
				</ul>
			</div>
		</a>
	);
};

export default ApartmentItem;
